/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BaseUrl from "../../BaseUrl";
import { useSelector } from "react-redux";
import axios from "axios";

function Jobcategories() {
  const token = useSelector((state) => state.auth.auth);

  const [data, setdata] = useState([]);
  useEffect(() => {
    handleGetcategory();
  }, []);

  const handleGetcategory = () => {
    var config = {
      method: "get",
      url: `${BaseUrl.baseurl}/category/view`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };

    axios(config)
      .then((res) => {
        // console.log(res, "category");
        setdata(res?.data?.category);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="row sp20">
      {data?.map((item, index) => (
        <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
          <div className="icon-bx-wraper">
            <div className="icon-content">
              <div className="icon-md text-primary m-b20">
                <i className="ti-location-pin"></i>
              </div>
              <Link to={"/Login"} className="dez-tilte">
                {item.name}
              </Link>
              <p className="m-a0">198 Open Positions</p>
              <div className="rotate-icon">
                <i className="ti-location-pin"></i>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* <div className="col-lg-12 text-center m-t30">
				<button className="site-button radius-xl">All Categories</button>
			</div> */}
    </div>
  );
}

export default Jobcategories;
